<ion-header translucent="true">
  <ion-toolbar>
    <ion-title class="headerWithLogo">
      <span *ngIf="versionService.tenantName">{{
        versionService.tenantName + " - "
      }}</span
      >{{ title }}
    </ion-title>
    <ion-buttons slot="end">
      <span class="fi flag-large" [class]="currentFlagClass"></span>
      &nbsp;
      <ion-select
        [value]="selectedLanguage"
        (ionChange)="onLanguageChange($event)"
        placeholder=""
        [okText]="'buttons.ok' | translate"
        [cancelText]="'buttons.cancel' | translate"
        interface="popover"
        class="language-select"
      >
        <ion-select-option
          *ngFor="let language of languages"
          [value]="language.code"
        >
          {{ language.name }}
        </ion-select-option>
      </ion-select>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
